import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-utilitats-page',
  templateUrl: './utilitats-page.component.html'
})
export class UtilitatsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
